import { FilterItem } from '@/components/molecules';
import { FacetValue } from '@/lib/models/types/product';
import { TFunction, useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ICategoriesListMobileBrandCmp } from './ICategoriesListMobileBrandCmp';

const FilterItemWrapper = styled.div`
  margin-bottom: 4px;
`;

const CategoriesWrapper = styled.div`
  padding: 0 12px;
  height: calc(100% - 150px);
  overflow-y: auto;
`;
const CategoriesListMobileBrand: React.FC<ICategoriesListMobileBrandCmp> = ({
  queryParameters,
  cmsCollectionTags,
  categorySelectHandler,
  selected,
  facetFoundValues,
  all,
}) => {
  const { t } = useTranslation(['catalog']);
  const [list, setList] = useState<any[]>([]);
  const router = useRouter();

  let { slug } = router.query;

  useEffect(() => {
    let list: any[] = [];

    if (cmsCollectionTags) {
      list = getBrowseCategories(
        facetFoundValues,
        selected as string[],
        queryParameters,
        categorySelectHandler,
        [slug as string],
        all,
        t
      );
    }

    setList(list);
  }, [selected]);

  return (
    <CategoriesWrapper className={'customWrapper'}>{list}</CategoriesWrapper>
  );
};

export default CategoriesListMobileBrand;

const getBrowseCategories = (
  categoryPathFacetValues: FacetValue[],
  selected: string[],
  queryParameters: { [key: string]: string | string[] | undefined },
  categorySelectHandler: (selected: string[]) => void,
  slug: string[],
  all: string[],
  t: TFunction
): JSX.Element[] => {
  let cat = [];

  if (categoryPathFacetValues && categoryPathFacetValues.length > 0) {
    cat.push(
      <FilterItemWrapper key={`filter-all-products`}>
        <FilterItem
          label={t('catalog:all-products')}
          active={selected.join('/') === all.join('/')}
          clickHandler={() => {
            categorySelectHandler(all);
          }}
          hasChildren={false}></FilterItem>
      </FilterItemWrapper>
    );

    categoryPathFacetValues.forEach((categoryPath, index) => {
      let isActiveCategoryPath: boolean = false;

      if (selected && selected.length > 0) {
        isActiveCategoryPath =
          selected.slice(1).join('/') === categoryPath.queryValue;
      } else {
        if (queryParameters['category-path']) {
          isActiveCategoryPath =
            queryParameters['category-path'] === categoryPath.queryValue;
        }
      }

      let splitCategoryPath = categoryPath?.queryValue.toLowerCase().split('/');

      let label = categoryPath?.displayValue;
      let linkQueryParameters = { ...queryParameters };

      if (
        (!selected || selected.length === 0) &&
        categoryPath?.queryValue !== ''
      ) {
        linkQueryParameters = {
          ...linkQueryParameters,
          ...{
            'category-path': categoryPath?.queryValue,
          },
        };
      }

      let catParameter = {};

      if (!selected || selected?.length === 0) {
        if (isActiveCategoryPath) {
          splitCategoryPath = splitCategoryPath.slice(
            0,
            splitCategoryPath.length - 1
          );
        }
        let arrCatString = splitCategoryPath.join('/');

        if (arrCatString.length > 0) {
          catParameter = { 'category-path': arrCatString };
          linkQueryParameters = {
            ...linkQueryParameters,
            ...catParameter,
          };
        } else {
          delete linkQueryParameters['category-path'];
        }
      }

      let filterItem = (
        <FilterItemWrapper key={`filter-${categoryPath?.id}${index}`}>
          <FilterItem
            label={label}
            active={
              selected && selected.length > 0
                ? selected.slice(1).join('/') === categoryPath?.queryValue
                : false
            }
            clickHandler={() => {
              let categoryToSet = [];
              if (
                slug &&
                slug.length > 0 &&
                slug.slice(1).join('/').includes(categoryPath?.queryValue)
              ) {
                categoryToSet = slug;
              } else {
                categoryToSet = [
                  selected && selected.length > 0 ? selected[0] : '',
                  ...categoryPath?.queryValue.split('/'),
                ];
              }

              categorySelectHandler(categoryToSet);
            }}
            hasChildren={
              categoryPath.values && categoryPath.values.length > 0
            }></FilterItem>
        </FilterItemWrapper>
      );

      cat.push(filterItem);
    });
  }

  return cat;
};
